
import Zel from "../../../assets/outline/Zel.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ZelIcon({ className, dataTestid = "ZelIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Zel data-testid={dataTestid} className={classes} {...rest} />
  );
}
